import { twMerge } from "tailwind-merge";
import clsx from "clsx";

export function Card({
  className, children, elevated = true,
}: React.PropsWithChildren<{ className?: string; elevated?: boolean }>) {
  return (
    <div className={twMerge(clsx(
      "bg-white rounded-xl border border-surface-200",
      elevated && "shadow-elevate-1",
      className,
    ))}>
      {children}
    </div>
  );
}

export function CardHeader({ className, children }: React.PropsWithChildren<{ className?: string }>) {
  return (
    <div className={twMerge(clsx(
      "px-5 py-4 border-b border-surface-200 flex items-center justify-between gap-3",
      className,
    ))}>{children}</div>
  );
}

export function CardTitle({ children }: React.PropsWithChildren) {
  return <h3 className="text-base font-semibold text-surface-900">{children}</h3>;
}

export function CardBody({ className, children }: React.PropsWithChildren<{ className?: string }>) {
  return <div className={twMerge("p-5", className)}>{children}</div>;
}

export function CardFooter({ className, children }: React.PropsWithChildren<{ className?: string }>) {
  return (
    <div className={twMerge(clsx(
      "px-5 py-4 border-t border-surface-200 flex items-center justify-end gap-2",
      className,
    ))}>{children}</div>
  );
}
